// components/BarChart.js
import { Line } from "react-chartjs-2";
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPassengerCountAction } from '../../redux/action';
import { CategoryScale } from 'chart.js';
import Chart from 'chart.js/auto';

const PassengerChart = () => {
    const data = useSelector(state => state.passengers)

    Chart.register(CategoryScale);
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getPassengerCountAction())
    }, [])


    const [chartData, setChartData] = useState({ labels: [], datasets: [] })
    useEffect(() => {
        if (data) {
            setChartData({
                labels: data?.p?.map((d) => d.date),
                datasets: [
                    {
                        label: "İstifadəçi sayı",
                        data: data?.p?.map((d) => d.count),
                        backgroundColor: '#6F52EA',
                        borderColor: "#6F52EA",
                        borderWidth: 1
                    }
                ]
            })
        }
    }, [data]);
    return (
        <div className="chart-container" style={{ margin: 30, width: '70%', alignItems: 'center' }}>
            <Line
                data={chartData}
                options={{
                    plugins: {
                        title: {
                            display: true,
                            text: "İstifadəçi Statistikası: Sentyabr-İndi"
                        },
                        legend: {
                            display: true
                        }
                    }
                }}
            />
        </div>
    );
};
export default PassengerChart